// import React from "react";

// class PrintDemo extends React.Component {
//   constructor(props) {
//     super(props);
//     this.printRef = React.createRef();
//   }

//   handlePrint = () => {
//     const content = this.printRef.current;

//     const printWindow = window.open('', '', 'height=600,width=800');

//     printWindow.document.write(`
//       <html>
//         <head>
//           <title>Print Preview</title>
//           <style>
//             @media print {
//               body {
//                 -webkit-print-color-adjust: exact;
//               }
//             }
//             body {
//               font-family: Arial, sans-serif;
//               padding: 20px;
//             }
//           </style>
//         </head>
//         <body>
//           ${content.innerHTML}
//         </body>
//       </html>
//     `);

//     printWindow.document.close();

//     printWindow.onload = function () {
//       printWindow.focus();
//       printWindow.print();
//       printWindow.close();
//     };
//   };

//   render() {
//     return (
//       <div>
//         <button
//           onClick={this.handlePrint}
//           style={{
//             marginTop: "50px",
//             padding: "10px 20px",
//             fontSize: "16px",
//             cursor: "pointer",
//           }}
//         >
//           Print to PDF!
//         </button>

//         <div
//           ref={this.printRef}
//           style={{
//             padding: 20,
//             marginTop: 20,
//             background: "#fff",
//             color: "red"
//           }}
//         >
//           <h1>Hello from PrintDemo</h1>
//           <p>This content will open in browser print preview (same as Ctrl+P).</p>
//         </div>
//       </div>
//     );
//   }
// }

// export default PrintDemo;

import React, { Component } from "react";
import ReactToPrint from "react-to-print";

class HallTicket extends Component {
  render() {
    return (
      <div style={{ padding: "20px", background: "#fff", color: "#000" }}>
        <h2>Hall Ticket</h2>
        <p>Name: John Doe</p>
        <p>Roll No: 123456</p>
      </div>
    );
  }
}

export default class PrintDemo extends Component {
  constructor(props) {
    super(props);
    this.componentRef = React.createRef();
  }

  render() {
    return (
      <div>
        <ReactToPrint
          trigger={() => <button aria-label="Print Hall Ticket" type="button">Print Hall Ticket</button>}
          content={() => this.componentRef.current}
        />
        {/* Hidden until printing */}
        <div style={{ display: "none" }}>
          <HallTicket ref={this.componentRef} />
        </div>
      </div>
    );
  }
}